<template>
  <v-sheet outlined width="100%">
    <v-form ref="form">
      <v-row justify="space-between" no-gutters>
        <v-col cols="4"  class="pb-0" style="padding-top: 30px">
          <SelectField
                  v-model="value.language"
                  :name="label('language')"
                  :items="languages"
                  required
                  class="pb-0"
          />
          <TextField
                v-if="isOtherLanguage"
                v-model="value.otherLanguage"
                :name="label('other')"
                :required="requiredOther"
                class="pb-0"
          />
        </v-col>
        <v-col cols="5" class="pb-0" style="padding-top: 30px">
          <SelectField
                  v-model="value.languageLevel"
                  :name="label('level')"
                  :items="languageLevels"
                  required
          />
        </v-col>
        <v-col cols="1" style="padding-top: 43px; text-align:center">
          <v-btn small depressed outlined color="primary" @click="add">{{label("add")}}</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-sheet>
</template>

<script>
  import SelectField from "../atoms/SelectField";
  import TextField from "../atoms/TextField";
  import {languages} from "../../enums";
  import ComponentMixin from "../ComponentMixin";
  import {mapGetters} from "vuex";
  import ApiMixin from "../../ApiMixin";

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "molecule",
    name: "LanguageForm",
    props: {
      "value": {
        type: Object,
        default: () => ({
        })
      }
    },
    data () {
      return {
        data: {
        },
        errorMessage: null
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      isOtherLanguage () {
        if ( this.value.language === 99 ) {
          return true;
        }
        if (this.value.otherLanguage){
          this.$delete(this.value, 'otherLanguage')
        }
        return false;
      },
      languages () {
        if (this.$i18n.locale === 'en'){
          return languages.en
        }
        return languages.ja
      },
      languageLevels () {
        return this.consts.languageLevel
      },
      requiredOther () {
        return this.value.language === 99;
      }
    },
    methods: {
      submit () {},
      add () {
        if(this.$refs.form.validate()){
          this.$emit("addLanguage");
          this.$refs.form.reset();
        }
      }
    },
    components: {
      SelectField,
      TextField,
      // ErrorMessage,
    }
  }
</script>

<style scoped>

</style>
